import { useContext, useEffect, useMemo, useState } from 'react';
import { myUserDataContext } from '../../../App';
import axios from 'axios';
import { notify } from '../../../functions/toasts';
import { convertToPersianDate } from '../../../functions/convertToPersianDate';
import { useParams } from 'react-router-dom';
import Loading from '../../../shared/Loading';

const Logs = () => {
  const [isloadTableLogs, setIsLoadTableLogs] = useState(true);
  const [dataTableLogs, setDataTableLogs] = useState([]);
  const [updatedData, setUpdatedData] = useState([]);

  const data = useContext(myUserDataContext);
  const { userData, isLogin, mainUrl } = data;
  const { token } = userData;
  const { id } = useParams();

  const getLogs = () => {
    setIsLoadTableLogs(true);

    axios
      .get(`/landing/get-landing-activities/${id}`, {
        // .get(`/landing/get-landing-activities/36598`, {
        // .get(`/landing/get-landing-activities/36597`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.status) {
          setDataTableLogs(res.data.data);
          setIsLoadTableLogs(false);
        } else {
          notify('اطلاعات یافت نشد', 'error');
          console.log(res);
        }
      })
      .catch((error) => {
        notify('مشکل در دریافت', 'error');
        console.log(error);
      });
  };

  useEffect(() => {
    getLogs();
  }, [id]);

  const filteredData = useMemo(() => {
    return dataTableLogs.filter((item) => item.event !== 'created');
  }, [dataTableLogs]);

  useEffect(() => {
    if (filteredData?.length > 0) {
      const updatedData = filteredData.map((item) => {
        try {
          const newParameters = JSON.parse(
            item?.properties?.attributes?.parameters || '{}'
          );
          const oldParameters = JSON.parse(
            item?.properties?.old?.parameters || '{}'
          );

          const getDifferences = (newParams, oldParams) => {
            const differences = [];

            for (const key in newParams) {
              if (newParams[key] !== oldParams[key]) {
                differences.push({
                  key,
                  newValue: newParams[key],
                  oldValue: oldParams[key],
                });
              }
            }

            return differences;
          };

          item.differences = getDifferences(
            newParameters,
            oldParameters
          );
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
        return item;
      });
      setUpdatedData(updatedData);
    }
  }, [filteredData]);

  return (
    updatedData?.length > 0 &&
    updatedData?.map((rows, index) =>
      isloadTableLogs ? (
        <Loading color="#ffc107" height="100px" text={false} />
      ) : (
        <div
          style={{
            backgroundColor: '#F7F7F7',
            margin: '30px',
            padding: '10px',
            overflowX: 'auto',
            width: '90%',
          }}
        >
          <h3
            style={{ marginBottom: '50px', color: '#77B254' }}
          >{`بروزرسانی در ${convertToPersianDate(rows.updated_at)} ${
            rows.updated_at?.split(' ')[1]
          } توسط ${rows.causer.first_name} ${
            rows.causer.last_name
          }`}</h3>
          <h4 style={{ color: '#536493', fontWeight: 'bold' }}>
            تغییرات عمومی
          </h4>
          <table
            style={{
              borderCollapse: 'collapse',
              width: 'max-content',
              minWidth: '90%',
              margin: '20px',
              textAlign: 'center',
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                    color: '#fff',
                    backgroundColor: '#536493',
                  }}
                >
                  #
                </th>
                <th
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                    color: '#fff',
                    backgroundColor: '#536493',
                  }}
                >
                  توضیحات
                </th>
                <th
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                    color: '#fff',
                    backgroundColor: '#536493',
                  }}
                >
                  Slug
                </th>
                <th
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                    color: '#fff',
                    backgroundColor: '#536493',
                  }}
                >
                  عنوان
                </th>
                <th
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                    color: '#fff',
                    backgroundColor: '#536493',
                  }}
                >
                  نام
                </th>
                <th
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                    color: '#fff',
                    backgroundColor: '#536493',
                  }}
                >
                  نام خانوادگی
                </th>
                <th
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                    color: '#fff',
                    backgroundColor: '#536493',
                  }}
                >
                  موبایل
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                    color: '#536493',
                  }}
                >
                  مقدار جدید
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                  }}
                >
                  {rows?.properties?.attributes?.description || '-'}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                  }}
                >
                  {rows?.properties?.attributes?.slug || '-'}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                  }}
                >
                  {rows?.properties?.attributes?.title || '-'}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                  }}
                >
                  {rows?.properties?.attributes?.user?.first_name ||
                    '-'}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                  }}
                >
                  {rows?.properties?.attributes?.user?.last_name ||
                    '-'}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                  }}
                >
                  {rows?.properties?.attributes?.user?.mobile || '-'}
                </td>
              </tr>

              <tr>
                <td
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                    color: '#536493',
                  }}
                >
                  مقدار قدیم
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                  }}
                >
                  {rows?.properties?.old?.description || '-'}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                  }}
                >
                  {rows?.properties?.old?.slug || '-'}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                  }}
                >
                  {rows?.properties?.old?.title || '-'}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                  }}
                >
                  {rows?.properties?.old?.user?.first_name || '-'}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                  }}
                >
                  {rows?.properties?.old?.user?.last_name || '-'}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                  }}
                >
                  {rows?.properties?.old?.user?.mobile || '-'}
                </td>
              </tr>
            </tbody>
          </table>

          {rows?.differences?.length > 0 && (
            <>
              <h4
                style={{
                  color: '#536493',
                  fontWeight: 'bold',
                  marginTop: '70px',
                }}
              >
                تغییرات پارامتر
              </h4>
              <table
                style={{
                  borderCollapse: 'collapse',
                  width: 'max-content',
                  minWidth: '90%',
                  margin: '20px',
                  textAlign: 'center',
                }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        border: '1px solid black',
                        padding: '8px',
                        color: '#fff',
                        backgroundColor: '#536493',
                      }}
                    >
                      پارامتر
                    </th>
                    <th
                      style={{
                        border: '1px solid black',
                        padding: '8px',
                        color: '#fff',
                        backgroundColor: '#536493',
                      }}
                    >
                      مقدار جدید
                    </th>
                    <th
                      style={{
                        border: '1px solid black',
                        padding: '8px',
                        color: '#fff',
                        backgroundColor: '#536493',
                      }}
                    >
                      مقدار قدیم
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {rows?.differences?.map((item, index) => (
                    <tr key={`${index}`} className="text-center">
                      <td
                        style={{
                          border: '1px solid black',
                          padding: '8px',
                          color: '#536493',
                        }}
                      >
                        {item.key}
                      </td>
                      <td
                        style={{
                          border: '1px solid black',
                          padding: '8px',
                          maxWidth: '200px',
                        }}
                      >
                        {item.newValue}
                      </td>
                      <td
                        style={{
                          border: '1px solid black',
                          padding: '8px',
                          maxWidth: '200px',
                        }}
                      >
                        {item.oldValue}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </div>
      )
    )
  );
};

export default Logs;
